import {PlantStageType} from "../../api/Constants";
import {
    CloneRoomId,
    Flower1RoomId,
    Flower2RoomId,
    Flower3RoomId,
    Flower4RoomId,
    Harvest1RoomId, Harvest2RoomId,
    VegRoomId
} from "../../api/RoomConstants";

export const getPlantRoomTransferOptions = (location, roomMap, plantRoomId, stage, undo=false) => {
    const roomOptions = [];
    if (undo === false) {
        if (stage === PlantStageType.Clone) {
            roomOptions.push({value: VegRoomId, label: roomMap[VegRoomId].name});
        } else if (stage === PlantStageType.Veg) {
            roomOptions.push({value: Flower1RoomId, label: roomMap[Flower1RoomId].name})
            roomOptions.push({value: Flower2RoomId, label: roomMap[Flower2RoomId].name})
            roomOptions.push({value: Flower3RoomId, label: roomMap[Flower3RoomId].name})
            roomOptions.push({value: Flower4RoomId, label: roomMap[Flower4RoomId].name})
        } else if (stage === PlantStageType.Flower) {
            roomOptions.push({value: Harvest1RoomId, label: roomMap[Harvest1RoomId].name})
            roomOptions.push({value: Harvest2RoomId, label: roomMap[Harvest2RoomId].name})

            // allow transfer to another flower room
            if (plantRoomId !== Flower1RoomId) {
                roomOptions.push({value: Flower1RoomId, label: roomMap[Flower1RoomId].name})
            }
            if (plantRoomId !== Flower2RoomId) {
                roomOptions.push({value: Flower2RoomId, label: roomMap[Flower2RoomId].name})
            }
            if (plantRoomId !== Flower3RoomId) {
                roomOptions.push({value: Flower3RoomId, label: roomMap[Flower3RoomId].name})
            }
            if (plantRoomId !== Flower4RoomId) {
                roomOptions.push({value: Flower4RoomId, label: roomMap[Flower4RoomId].name})
            }
        } else if (stage === PlantStageType.Harvest) {
            if (plantRoomId !== Harvest1RoomId) {
                roomOptions.push({value: Harvest1RoomId, label: roomMap[Harvest1RoomId].name})
            }
            if (plantRoomId !== Harvest2RoomId) {
                roomOptions.push({value: Harvest2RoomId, label: roomMap[Harvest2RoomId].name})
            }
        }
    } else {
        // undo is true, so provide the reverse logic
        if (stage === PlantStageType.Flower) {
            roomOptions.push({value: VegRoomId, label: roomMap[VegRoomId].name});
        } else if (stage === PlantStageType.Harvest) {
            roomOptions.push({value: Flower1RoomId, label: roomMap[Flower1RoomId].name})
            roomOptions.push({value: Flower2RoomId, label: roomMap[Flower2RoomId].name})
            roomOptions.push({value: Flower3RoomId, label: roomMap[Flower3RoomId].name})
            roomOptions.push({value: Flower4RoomId, label: roomMap[Flower4RoomId].name})
        } else if (stage === PlantStageType.Veg) {
            roomOptions.push({value: CloneRoomId, label: roomMap[CloneRoomId].name})
        }
    }

    return roomOptions;
}